import { VendorDCCreateError } from '../../constants';
import serviceInterceptor from '../../services/ServiceInterceptor';

export const createVendorDC = async ({
  vendorID,
  dcName,
  dcStreet,
  dcCity,
  dcState,
  dcZip,
  dcCode,
}) => {
  try {
    const bodyFormData = new FormData();
    bodyFormData.append('vendorid', vendorID);
    bodyFormData.append('name', dcName);
    bodyFormData.append('street', dcStreet);
    bodyFormData.append('city', dcCity);
    bodyFormData.append('state', dcState);
    bodyFormData.append('zip', dcZip);
    bodyFormData.append('code', dcCode);

    const response = await serviceInterceptor.post(
      `/vendor/distributioncenter`, // TODO NOT RESTFUL!!
      bodyFormData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    if (!response?.data?.success) {
      throw VendorDCCreateError;
    }
    return response.data;
  } catch (error) {
    throw VendorDCCreateError;
  }
};
